import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGermline = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 26 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "m25 13.068-3.637 3.637-3.638-3.637m3.637 3.132V4.843",
		stroke: "currentColor",
		strokeWidth: 1.805,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M14.476 18.657v1.387h-.99v-1.387c0-1.432-.684-2.572-1.796-3.655L11.69 15c-.671-.647-1.525-1.268-2.416-1.869l.904-.588c.795.548 1.55 1.127 2.19 1.752 1.232 1.198 2.11 2.636 2.11 4.362Zm-12.487 0v1.387H1v-1.387c0-1.726.877-3.164 2.11-4.362 1.222-1.196 2.79-2.192 4.36-3.187l.003-.002c1.55-.992 3.103-1.986 4.216-3.062l.001-.002c1.112-1.084 1.797-2.223 1.797-3.655V3h.99v1.387c0 1.726-.878 3.164-2.11 4.362-1.222 1.196-2.791 2.192-4.36 3.187h-.001l-.002.002C6.454 12.93 4.9 13.924 3.787 15v.002c-1.113 1.083-1.798 2.223-1.798 3.655ZM3.788 8.044c.67.647 1.524 1.268 2.416 1.869L5.3 10.5c-.795-.548-1.55-1.127-2.19-1.752C1.877 7.551 1 6.113 1 4.387V3h.99v1.387c0 1.432.684 2.571 1.796 3.655l.002.002ZM11.8 19.152H3.676v-.471l.008-.073h8.108l.008.073v.471Zm-1.033-2.676H4.71c.076-.084.158-.169.246-.255l.334-.288h4.91l.317.285c.09.087.172.173.25.258Zm-.247-9.653-.334.288H5.277l-.318-.285a6.118 6.118 0 0 1-.25-.258h6.058c-.077.084-.159.169-.247.255Zm1.28-2.46-.008.072H3.684l-.008-.072v-.471H11.8v.47Z",
		fill: "currentColor",
		stroke: "currentColor",
		strokeWidth: .794
	})]
});
export default SvgGermline;
